import { ProductSubscribeGate } from "../../../products/subscribe_gate/ProductSubscribeGate";
import type { MembershipProduct, SpaceProfile } from "../SpaceType";
import { SpaceHomeMembershipSection } from "./SpaceHomeMembershipSection";

export function SpaceModuleSubscribeGate(props: {
  spaceId: string;
  row: MembershipProduct;
  isLoggedIn: boolean;
  onLoginRequest: () => void;
  spaceProfile: SpaceProfile | null;
}): JSX.Element {
  const { spaceId, row, isLoggedIn, onLoginRequest, spaceProfile } = props;
  return (
    <ProductSubscribeGate row={row}>
      <SpaceHomeMembershipSection
        spaceId={spaceId}
        row={row}
        isLoggedIn={isLoggedIn}
        onLoginRequest={onLoginRequest}
        spaceProfile={spaceProfile}
        subscribeCtaLabel="订阅"
        subscribeCtaPresentation="button"
        subscribePrimaryButtonClassName="space-access-gate__subscribe-btn"
      />
    </ProductSubscribeGate>
  );
}
